var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDebug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.479,
    height: 27.609,
    viewBox: "0 0 17.479 27.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M-3.293-8.554a12.077,12.077,0,0,1,.612-4.277A6.689,6.689,0,0,1-.7-15.549a13.2,13.2,0,0,0,2.087-2.106,3.438,3.438,0,0,0,.714-2.106q0-2.8-2.412-2.8a2.238,2.238,0,0,0-1.8.816,3.472,3.472,0,0,0-.724,2.208H-9.1a7.481,7.481,0,0,1,2.338-5.78A9.321,9.321,0,0,1-.306-27.387,9.683,9.683,0,0,1,6.1-25.476a6.708,6.708,0,0,1,2.273,5.437,6.332,6.332,0,0,1-.612,2.8A9.469,9.469,0,0,1,5.8-14.658L3.665-12.673A5.02,5.02,0,0,0,2.4-10.882a7.1,7.1,0,0,0-.39,2.329Zm-.761,5.641a2.88,2.88,0,0,1,.993-2.254A3.594,3.594,0,0,1-.584-6.049a3.594,3.594,0,0,1,2.477.881,2.88,2.88,0,0,1,.993,2.254A2.88,2.88,0,0,1,1.893-.659,3.594,3.594,0,0,1-.584.223,3.594,3.594,0,0,1-3.062-.659,2.88,2.88,0,0,1-4.054-2.913Z",
    transform: "translate(9.101 27.387)",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDebug);
export default __webpack_public_path__ + "static/media/icon-debug.450e3b838fbde9d6cbaef8e8276b2ac9.svg";
export { ForwardRef as ReactComponent };